export const skills = [
    {
        id: 1,
        title: 'Linux',
        img: '/assets/linux.png',
        url: 'https://docs.kernel.org'
    },
	{
        id: 2,
        title: 'Kubernetes',
        img: '/assets/kubernetes.png',
        url: 'https://kubernetes.io/docs/home/'
    },
    {
        id: 3,
        title: 'Docker',
        img: '/assets/docker.png',
        url: 'https://docs.docker.com'
    },
    {
        id: 4,
        title: 'Jenkins',
        img: '/assets/jenkins.png',
        url: 'https://www.jenkins.io/'
    },
	{
        id: 5,
        title: 'Helm',
        img: '/assets/helm2.png',
        url: 'https://helm.sh/'
    },
	{
        id: 11,
        title: 'Istio',
        img: '/assets/istio.png',
        url: 'https://istio.io/'
    },
	{
		id: 7,
		title: 'Ansible',
		img: '/assets/ansible.png',
		url: 'https://www.ansible.com/'
	},
	{
		id: 8,
		title: 'Terraform',
		img: '/assets/terraform.png',
		url: 'https://developer.hashicorp.com/terraform/docs'
	},
    {
        id: 9,
        title: 'Python',
        img: '/assets/python.png',
        url: 'https://www.python.org/doc/'
    },
    {
        id: 10,
        title: 'Java',
        img: '/assets/java.png',
        url: 'https://docs.oracle.com/en/java/'
    },
	{
        id: 11,
        title: 'GitHub',
        img: '/assets/github.png',
        url: 'https://docs.github.com/en'
    },
    {
        id: 12,
        title: 'Jira',
        img: '/assets/jira2.png',
        url: 'https://www.atlassian.com/software/jira/features'
    },
    {
        id: 13,
        title: 'AWS',
        img: '/assets/aws.png',
        url: 'https://docs.aws.amazon.com/'
    },
	{
		id: 14,
		title: 'Cucumber',
		img: '/assets/cucumber.png',
		url: 'https://cucumber.io/'
	},
    {
        id: 15,
        title: 'Cypress',
        img: '/assets/cypress.png',
        url: 'https://www.cypress.io/'
    },
    {
        id: 16,
        title: 'Playwright',
        img: '/assets/playwright.png',
        url: 'https://playwright.dev/'
    },
	{
        id: 17,
        title: 'RestAssured',
        img: '/assets/restassured.png',
        url: 'https://rest-assured.io/'
    },
    {
        id: 18,
        title: 'Selenium',
        img: '/assets/selenium.png',
        url: 'https://www.selenium.dev/'
    },
    {
        id: 19,
        title: 'JMeter',
        img: '/assets/jmeter.png',
        url: 'https://jmeter.apache.org/'
    },
    {
        id: 20,
        title: 'GitLab',
        img: '/assets/gitlab.png',
        url: 'https://about.gitlab.com/'
    },
    {
        id: 21,
        title: 'Tableau',
        img: '/assets/tableau.png',
        url: 'https://www.tableau.com/'
    },
    {
        id: 22,
        title: 'PowerBI',
        img: '/assets/powerbi.jpeg',
        url: 'https://www.microsoft.com/en-us/power-platform/products/power-bi/?msockid=0323dcbf0031624c0c93cf2f04316c58'
    },
    {
        id: 23,
        title: 'IBM Cognos',
        img: '/assets/ibm-cognos.png',
        url: 'https://www.ibm.com/products/cognos-analytics'
    }
]